/* eslint-disable */
import axios from 'axios';
import { API2_HOST } from '../helpers/urlHelper';
import dayjs from 'dayjs';
import { themeColors } from 'helpers/utils';
import customParseFormat from 'dayjs/plugin/customParseFormat'

axios.defaults.withCredentials = true;
const _URL = `${API2_HOST}/stillage-dashboard`;
//const _URL = `https://api2-dev.emplas.co.uk/v1/stillage-dashboard`;
const mapApiKey = process.env.REACT_APP_GOOGLE_API_KEY || "";
dayjs.extend(customParseFormat);
const format = 'DD/MM/YYYY';
const formatHrs = 'DD/MM/YYYY HH:mm';
const minDate = dayjs('0001-01-01T00:00:00');

const classToColor = {
    'bg-primary': themeColors.primary,
    'bg-success': themeColors.success,
    'bg-secondary': themeColors.secondary,
    'bg-danger': themeColors.danger,
    'bg-info': themeColors.info,
    'bg-warning': themeColors.warning
}
class stillageType {
    constructor(text, className) {
        this.text = text;
        this.class = className;
        this.label = `<span class="badge rounded-pill ${className}">${text}</span>`;
        this.colour = classToColor[className]
    }
}
const stillageTypes = {
    'stillage.craneable': new stillageType('Craneable', 'bg-success'),
    'stillage.special.craneable': new stillageType('Special Craneable', 'bg-secondary'),
    'stillage.aframe': new stillageType('AFrame', 'bg-danger'),
    'glass.stillage': new stillageType('Glass', 'bg-info'),
    'wooden.stillage': new stillageType('Wooden', 'bg-warning'),
    'Standard': new stillageType('Standard', 'bg-primary'),
}

const defaultMapProps = {
    center: {
        lat: 52.301304177793234,
        lng: -0.7387896140574738
    },
    zoom: 6
};

const tableColumns = [
    {
        accessor: 'stillageNo',
        Header: 'Stillage No',
        isVisible: true
    },
    {
        accessor: 'stillageType.label',
        Header: 'Type',
        isVisible: true,
        Cell: ({ value }) => (
            <span className="align-middle" dangerouslySetInnerHTML={{ __html: value }} />
        )
    },
    {
        accessor: 'deliveryDate',
        Header: 'Delivery Date',
        isVisible: true,
        Cell: ({ value }) => value.split(' ')[0]
    },
    // {
    //     accessor: 'custCode',
    //     Header: 'Customer',
    //     isVisible: true
    // },
    {
        accessor: 'custName',
        Header: 'Customer Name',
        isVisible: true
    },
    {
        accessor: 'lostStillage',
        Header: 'Lost?',
        isVisible: true,
        Cell: ({ value }) => (
            value ? <span className="badge rounded-pill bg-danger">Lost</span> : <span className="badge rounded-pill bg-success">Active</span>
        )
    },
    {
        accessor: '',
        Header: 'Frames Fitted',
        isVisible: true,
        Cell: ({ row }) => (`${row.original.fittedFrames}/${row.original.totalFrames}`)
    },
    {
        accessor: 'battery',
        Header: 'Battery',
        isVisible: true,
        Cell: ({ value, row }) => {
            const tracker = row?.original?.trackerName;
            let text = ''
            let bg = ''

            if (!tracker) {
                text = 'No Tracker';
                bg = 'secondary';
            }
            else if (value > 0) {
                text = `OK ${value}`;
                bg = 'success';
            } else {
                text = 'Dead Battery';
                bg = 'danger';
            }
            return <span className={`badge rounded-pill bg-${bg}`}>{text}</span>;
        }
    },
    {
        accessor: 'deliveryAddress',
        Header: 'Delivery Address',
        isVisible: true
    },
    {
        accessor: 'lastAddress',
        Header: 'Last Tracked Address',
        isVisible: true
    },
    {
        accessor: 'stillageComment',
        Header: 'Stillage Comment',
        isVisible: true
    },
    // {
    //     accessor: 'trackerName',
    //     Header: 'Tracker Name',
    //     isVisible: true
    // },
    // {
    //     accessor: 'lastPoll',
    //     Header: 'Last Poll',
    //     isVisible: true
    // },
    {
        accessor: 'certStartDate',
        Header: 'Certificate Start',
        isVisible: true
    },
    {
        accessor: 'certEndDate',
        Header: 'Certificate End',
        isVisible: true
    },
    {
        accessor: 'certUploadDate',
        Header: 'Cert Upload Date',
        isVisible: true
    }
];

const getStillageTableDetails = async filters => {
    const { requiredDateFrom, requiredDateTo, stillageType, customer, query, stillageNo } = filters;
    const res = await axios({
        method: 'get',
        url: `${_URL}/stillage-list?requiredDateFrom=${requiredDateFrom}&requiredDateTo=${requiredDateTo}&stillageType=${stillageType}&customer=${customer}&query=${query}&stillageNo=${stillageNo}`
    }).catch(err => {
        console.error('dashboardData', err);
        return [];
    });

    if (res && Array.isArray(res.data) && res.data.length > 0) {
        return res.data.map(item => {
            return {
                ...item,
                certStartDate: isValidDate(item.certStartDate) ? dayjs(item.certStartDate).format(format) : '',
                certEndDate: isValidDate(item.certEndDate) ? dayjs(item.certEndDate).format(format) : '',
                certUploadDate: isValidDate(item.certUploadDate) ? dayjs(item.certUploadDate).format(formatHrs) : '',
                lastPoll: isValidDate(item.lastPoll) ? dayjs(item.lastPoll).format(formatHrs) : '',
                deliveryDate: isValidDate(item.deliveryDate) ? dayjs(item.deliveryDate).format(formatHrs) : '',
            }
        });
    }
    return [];
}

const getStillageTypeData = data => data.map(x => {
    return { ...x, stillageType: stillageTypes[x.stillageTypeName] }
})

const getStillageTrackerDetails = async () => {
    const res = await axios({
        method: 'get',
        url: `${_URL}/stillage-tracking-details`
    }).catch(err => {
        console.error('trackerData', err);
        return [];
    });

    if (res.status === 200) {
        return res.data;
    }
    return [];
}

const getStillageHistoryDetails = async stillageNo => {
    const res = await axios({
        method: 'get',
        url: `${_URL}/stillage-history?stillageNo=${stillageNo}`
    }).catch(err => {
        console.error('historyData', err);
        return [];
    });

    if (res.status === 200) {
        return res.data;
    }
    return [];
}

const updateStillageType = async (stillageNo, setting) => {
    const res = await axios.post(`${_URL}/update-stillage-type`, {
        StillageNo: stillageNo, Setting: setting
    })
        .catch(err => {
            console.error('Update stillage type', err);
            return false;
        });

    if (res.status === 200)
        return res.data;

    return false;
}

const getActiveCustomers = async () => {
    const res = await axios.get(`${_URL}/customer-list`)
        .catch(err => {
            console.error('Active customer error', err);
            return [];
        });

    if (res.status === 200)
        return res.data;
    return [];
}

const updateLostStillage = async (data) => {
    const res = await axios.post(`${_URL}/update-lost`, data)
        .catch(err => {
            console.log('Error updating lost stillage', err);
            return false;
        });

    if (res.status === 200 && res.data)
        return res.data;

    return false;
}

const isValidDate = date => date && dayjs(date).format(format) != '01/01/1901';

const getExpiringCertificatesData = certificates => {
    const expDate = dayjs().subtract(3, 'month');

    const expCerts = certificates?.filter(x => dayjs(x.certEndDate, format).isBefore(dayjs(expDate)));
    const notCert = certificates?.filter(x => !x.certStartDate || !isValidDate(x.certStartDate));
    const certified = certificates?.filter(x => dayjs(x.certEndDate, format).isAfter(dayjs(expDate)))

    return { expCerts, notCert, certified };
}


const sortBatteries = data => {
    let full = [];
    let empty = [];
    let low = [];

    data?.forEach(item => {
        if (item.battery)
            item.battery >= 50 ? full.push(item) : low.push(item);
        else
            empty.push(item);
    });

    return { full, empty, low };
}

const getTrackers = data => {
    // console.log(minDate)
    let tracked = data?.filter(x => dayjs(x.lastTrack).isAfter(minDate));
    let notTracked = data?.filter(x => dayjs(x.lastTrack).isSame(minDate));

    return { tracked, notTracked }
}

const isStillageAtEmplas = (lat, long) => (lat >= 52.0 && lat <= 53.0) && (long <= -0.73 && long >= -0.75);

export {
    getStillageTableDetails,
    getStillageTrackerDetails,
    getExpiringCertificatesData,
    getStillageHistoryDetails,
    isStillageAtEmplas,
    sortBatteries,
    getTrackers,
    getStillageTypeData,
    updateStillageType,
    getActiveCustomers,
    stillageType,
    updateLostStillage,
    stillageTypes,
    defaultMapProps,
    tableColumns,
    mapApiKey
};